import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';

var graphData = {
  detratores: [],
  passivos: [],
  promotores: [],
  nps: []
};

@Component({
  selector: 'dash-avaliacoes-graph',
  templateUrl: './avaliacoes-graph.component.html',
  styleUrls: ['./avaliacoes-graph.component.scss']
})
export class AvaliacoesGraphComponent implements OnInit {

  @Output() graphScreen = new EventEmitter();

  public loading: boolean;
  public topicsList: [];
  public avaliacaoList: [];
  public graphInfo: any;
  public year: string[] = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
  public pageSetup: any = {
    page: 1,
    limit: 7,
    topics: [],
    start_date: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    end_date: new Date()
  };
  //Grafico barras NPS
  //==========================================
  public barChartOptions: ChartOptions = {
    animation: {
      duration: 2500
    },
    responsive: true,
    legend: { display: false },
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        gridLines:{
          display:false
        },
        ticks:{
          min : 0,
          max: 100,
          stepSize : 50,
          fontColor : "transparent",
          fontSize : 10
        }
      }],
      xAxes: [{
        gridLines:{
          display:false
        },
        ticks:{
          min : 0,
          stepSize : 1,
          fontColor : "#8c97a3",
          fontSize : 10,

        }
      }]
    },
  };
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartData: ChartDataSets[];
  public barChartLabels: string[] = [];

  //Grafico linha NPS
  //=========================================
  public barChartOptionsL: ChartOptions = {
    animation: {
      duration: 2500
    },
    responsive: true,
    legend: { display: false },
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        gridLines:{
          display:false
        },
        ticks:{
          min : -100,
          max: 100,
          stepSize : 50,
          fontColor : "#8c97a3",
          fontSize : 10
        }
      }],
      xAxes: [{
        gridLines:{
          display:false
        },
        ticks:{
          min : 0,
          stepSize : 1,
          fontColor : "#98a5b3",
          fontSize : 10,

        }
      }]
    },
    tooltips: {
      enabled: false,
      custom: function(tooltipModel) {
        
        var tooltipEl = document.getElementById('chartjs-tooltip');

        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            document.body.appendChild(tooltipEl);
        }

        if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
            tooltipEl.classList.add('no-transform');
        }

        function getBody(bodyItem) {
            return bodyItem.lines;
        }

        if (tooltipModel.body) {
            var titleLines = tooltipModel.title || [];
            var bodyLines = tooltipModel.body.map(getBody);

            var innerHtml = '<div id="toolTipDiv">';

            titleLines.forEach(function(title) {
                innerHtml += '<div class="toolTitle>' + title + '</div>';
            });
            innerHtml += '<div id="graphContAll">';
            bodyLines.forEach(function(body, i) {
              innerHtml += '<span id="numRed">';
              innerHtml += body[0].split(':')[1];
              innerHtml += '</span> NPS';
              innerHtml += '<br/>';
              innerHtml += '<div class="npsLineCont">';
              innerHtml += '<div class="numCont">' + graphData.promotores[tooltipModel.dataPoints[0].index] + '%</div>';
              innerHtml += '<div class="colorContTotal"><div id="colorNpsGre"></div></div>';
              innerHtml += '</div>';
              innerHtml += '<div class="npsLineCont">';
              innerHtml += '<div class="numCont">' + graphData.passivos[tooltipModel.dataPoints[0].index] + '%</div>';
              innerHtml += '<div class="colorContTotal"><div id="colorNpsYel"></div></div>';
              innerHtml += '</div>';
              innerHtml += '<div class="npsLineCont">';
              innerHtml += '<div class="numCont">' + graphData.detratores[tooltipModel.dataPoints[0].index] + '%</div>';
              innerHtml += '<div class="colorContTotal"><div id="colorNpsRed"></div></div>';
              innerHtml += '</div>';
            });
            innerHtml += '</div>';
            innerHtml += '<div id="toolTipBaloon"></div>';
            
            innerHtml += '</div>';

            tooltipEl.innerHTML = innerHtml;
        }

        var position = this._chart.canvas.getBoundingClientRect();

        tooltipEl.style.opacity = '1';
        tooltipEl.style.zIndex = '10';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.left = (position.left - 80) + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = (position.top - 88) + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipEl.style.pointerEvents = 'none';

        document.getElementById('toolTipDiv').style.background = '#2f373c';
        document.getElementById('toolTipDiv').style.padding = '10px';
        document.getElementById('toolTipDiv').style.color = '#FFF';
        document.getElementById('toolTipDiv').style.borderRadius = '10px';
        document.getElementById('toolTipDiv').style.fontSize = '10px';
        document.getElementById('toolTipDiv').style.position = 'relative';

        document.getElementById('graphContAll').style.position = 'relative';
        document.getElementById('graphContAll').style.width = '125px';
        document.getElementById('graphContAll').style.minHeight = '50px';
        document.getElementById('graphContAll').style.textAlign = 'center';
        document.getElementById('graphContAll').style.zIndex = '1';
        
        document.getElementById('numRed').style.fontWeight = 'bold';
        document.getElementById('numRed').style.fontSize = '18px';

        document.getElementById('toolTipBaloon').style.position = 'absolute';
        document.getElementById('toolTipBaloon').style.bottom = '-2px';
        document.getElementById('toolTipBaloon').style.left = 'calc(50% - 5.5px)';
        document.getElementById('toolTipBaloon').style.transform = 'rotate(45deg)';
        document.getElementById('toolTipBaloon').style.width = '15px';
        document.getElementById('toolTipBaloon').style.height = '15px';
        document.getElementById('toolTipBaloon').style.zIndex = '0';
        document.getElementById('toolTipBaloon').style.background = 'rgb(47, 55, 60)';

        if(Number(tooltipModel.body.map(getBody)[0][0].split(':')[1]) <= 0){
          document.getElementById('numRed').style.color = 'rgb(255, 115, 115)';
        }
        if(Number(tooltipModel.body.map(getBody)[0][0].split(':')[1]) > 0 && 
            Number(tooltipModel.body.map(getBody)[0][0].split(':')[1]) <= 60){
          document.getElementById('numRed').style.color = 'rgb(255, 191, 45)';
        }
        if(Number(tooltipModel.body.map(getBody)[0][0].split(':')[1]) > 60){
          document.getElementById('numRed').style.color = 'rgb(0, 201, 151)';
        }

        if(document.getElementById('colorNpsRed') !== null){
          document.getElementById('colorNpsRed').style.width = graphData.detratores[tooltipModel.dataPoints[0].index] + '%';
          document.getElementById('colorNpsRed').style.height = '5px';
          document.getElementById('colorNpsRed').style.background = 'rgb(255, 115, 115)';
        }
        if(document.getElementById('colorNpsYel') !== null){
          document.getElementById('colorNpsYel').style.width = graphData.passivos[tooltipModel.dataPoints[0].index] + '%';
          document.getElementById('colorNpsYel').style.height = '5px';
          document.getElementById('colorNpsYel').style.background = 'rgb(255, 191, 45)';
        }
        if(document.getElementById('colorNpsGre') !== null){
          document.getElementById('colorNpsGre').style.width = graphData.promotores[tooltipModel.dataPoints[0].index] + '%';
          document.getElementById('colorNpsGre').style.height = '5px';
          document.getElementById('colorNpsGre').style.background = 'rgb(0, 201, 151)';
        }

        let npsLineCont = document.getElementsByClassName('npsLineCont') as HTMLCollectionOf<HTMLElement>;
        for (let i = 0; i < npsLineCont.length; i++) {
          npsLineCont[i].style.width = '35px';
          npsLineCont[i].style.minHeight = '20px';
          npsLineCont[i].style.float = 'left';
          if(i+1 < npsLineCont.length){
            npsLineCont[i].style.paddingRight = '10px';
          }
          npsLineCont[i].style.paddingTop = '5px';
          npsLineCont[i].style.textAlign = 'center';
        }

        let colorContTotal = document.getElementsByClassName('colorContTotal') as HTMLCollectionOf<HTMLElement>;
        for (let x = 0; x < colorContTotal.length; x++) {
          colorContTotal[x].style.width = '100%';
          colorContTotal[x].style.height = '3px';
          colorContTotal[x].style.overflow = 'hidden';
          colorContTotal[x].style.background = '#47525a';
          colorContTotal[x].style.borderRadius = '3px';
        }

        let numCont = document.getElementsByClassName('numCont') as HTMLCollectionOf<HTMLElement>;
        for (let y = 0; y < numCont.length; y++) {
          numCont[y].style.width = '100%';
          numCont[y].style.minHeight = '0px';
          numCont[y].style.textAlign = 'center';
        }
      }
    }
  };
  public barChartTypeL: ChartType = 'bar';
  public barChartLegendL = true;
  public barChartDataL: ChartDataSets[];
  public barChartLabelsL: string[] = [];

  constructor(private _customerService: CustomerService) {
    this.loading = true;
  }

  ngOnInit(): void {
    //Carregar customer list
    //=======================
    this.getCusmomers();
    //Carregar topics list
    //=====================
    this.getTopics();
    //Carregar info grafico e info bar right
    //=======================================
    this.getGraphInfos();
  }

  transformDate(date){
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(); // hoje
    const secondDate = new Date(date); // data que vem da lista
    const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
    return diffDays;
  }

  closeGraphScreen(){
    this.graphScreen.emit();
  }

  changeDate(data){
    if(data.targetElement.id === 'dataFinal' && data.value !== null){
      this.pageSetup.page = 1;
      this.avaliacaoList = [];
      this.resetTopics();
      this.getCusmomers();
      this.getTopics();
      this.getGraphInfos();
    }
  }

  topicsChange(input, idItem){
    if(input.currentTarget.checked){
      !this.pageSetup.topics.includes(idItem) ? this.pageSetup.topics.push(idItem) : null;
    }
    else{
      this.pageSetup.topics = this.pageSetup.topics.filter(item => item !== idItem);
    }
    this.pageSetup.page = 1;
    this.avaliacaoList = [];
    this.getCusmomers();
  }

  getCusmomers(){
    this._customerService.getCustomersEvaluationByProps(this.pageSetup).subscribe(data => {
      this.avaliacaoList = this.pageSetup.page > 1 ? this.avaliacaoList.concat(data.comments) : data.comments;
      this.loading = false;
    });
  }

  getTopics(){
    this._customerService.getTopics(this.pageSetup).subscribe(data => {
      this.topicsList = [];
      this.topicsList = data.topics;
      this.loading = false;
    });
  }

  getGraphInfos(){
    this._customerService.getNpsGraphData(this.pageSetup).subscribe(data => {
      this.resetGraphValues();
      this.graphInfo = data;
      this.graphInfo.months.forEach(month => {
        //Grafico de barras
        //======================================================
        graphData.detratores.push(month.num_detractor_percent);
        graphData.passivos.push(month.num_passive_percent);
        graphData.promotores.push(month.num_promoter_percent);
        this.barChartLabels.push(this.year[month.month - 1] + '' + month.date.split('-')[0].slice(-2));
        //Grafico de linha
        //=============================
        graphData.nps.push(month.nps);
        this.barChartLabelsL.push('');
      });
      //Grafico de barras
      //=====================
      this.barChartData = [
        { data: graphData.detratores, label: 'Detratores', stack: 'a', backgroundColor: "rgb(255 115 115)", hoverBackgroundColor: "rgb(255 115 115)"},
        { data: graphData.passivos, label: 'Passivos', stack: 'a', backgroundColor: "rgb(255 191 45)", hoverBackgroundColor: "rgb(255 191 45)"},
        { data: graphData.promotores, label: 'Promotores', stack: 'a', backgroundColor: "rgb(0 201 151)", hoverBackgroundColor: "rgb(0 201 151)"},
      ];
      //Grafico de linha
      //======================
      this.barChartDataL = [
        { data: graphData.nps, label: 'NPS', type: 'line', fill: false, borderColor : "#FFF", hoverBorderColor : "#FFF", borderWidth : 2, backgroundColor: "#FFF", hoverBackgroundColor: "#FFF", lineTension: 0, pointRadius: 4 },
      ];
      this.loading = false;
    });
  }

  resetGraphValues(){
    graphData = {
      detratores: [],
      passivos: [],
      promotores: [],
      nps: []
    };
    this.barChartLabels = [];
    this.barChartLabelsL = [];
  }

  resetTopics(){
    this.pageSetup.topics = [];
  }

  onScroll(event: any) {
    if (Math.ceil(event.target.offsetHeight + event.target.scrollTop) >= event.target.scrollHeight && this.avaliacaoList.length > 0) {
      this.pageSetup.page = this.pageSetup.page + 1;
      this.getCusmomers();
    }
  }
}
